import React from 'react'
import { faEarth, faEnvelope, faLocationDot, faMobile, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TaqaInfo = () => {

    return (
        <div className="lg:basis-2/6 md:basis-3/6 sm:basis-4/6 xs:basis-6/6 bg-slate-900 m-auto content-center my-5">
            <img src="/TaqaLogo.png" alt="image" className='mx-auto' />
            <p className='text-slate-100 my-1'>FOR GENERAL TRADING LTD</p>
            <div className='flex gap-5 text-slate-100 lg:my-5 md:my-3 sm:my-2 xs:my-1 p-2 justify-center'>
                <p className='my-auto'>المجموعة الثقافية - قرب اشارة المرور - الموصل - العراق</p>
                <FontAwesomeIcon icon={faLocationDot} size='lg' className='my-auto' />                
            </div>
            <div className='flex gap-5 text-slate-100 lg:my-5 md:my-3 sm:my-2 xs:my-1 p-2 justify-center'>
                <p className='my-auto'>info@taqagroup.com</p>
                <FontAwesomeIcon icon={faEnvelope} size='lg' className='my-auto' />
            </div>
            <div className='flex gap-5 text-slate-100 lg:my-5 md:my-3 sm:my-2 xs:my-1 p-2 justify-center'>
                <p className='my-auto'>+9647506222000</p>
                <FontAwesomeIcon icon={faPhone} size='lg' className='my-auto' />
            </div>
            <div className='flex gap-5 text-slate-100 lg:my-5 md:my-3 sm:my-2 xs:my-1 p-2 justify-center'>
                <p className='my-auto'>+9647506222000</p>
                <FontAwesomeIcon icon={faMobile} size='lg' className='my-auto' />
            </div>
            <div className='flex gap-5 text-slate-100 lg:my-5 md:my-3 sm:my-2 xs:my-1 p-2 justify-center'>
                <p className='my-auto'>http://www.taqagroup.com</p>
                <FontAwesomeIcon icon={faEarth} size='lg' className='my-auto' />
            </div>
        </div>
    )
}

export default TaqaInfo